var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwakenImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6301 7C59.6301 3.13401 56.4961 0 52.6301 0L38.7386 0C34.8726 0 31.7386 3.13401 31.7386 7V24.8198C31.7386 28.6858 28.6046 31.8198 24.7386 31.8198L7 31.8198C3.13401 31.8198 1.49684e-06 34.9538 1.17096e-06 38.8198L0 52.7112C-3.25879e-07 56.5772 3.13401 59.7112 7 59.7112L24.7386 59.7113C28.6046 59.7113 31.7386 62.8453 31.7386 66.7113V84.8425C31.7386 88.7085 34.8726 91.8425 38.7386 91.8425H52.6301C56.4961 91.8425 59.6301 88.7085 59.6301 84.8425V66.7113C59.6301 62.8453 62.7641 59.7113 66.6301 59.7113L84.8425 59.7113C88.7085 59.7113 91.8425 56.5773 91.8425 52.7113V38.8198C91.8425 34.9538 88.7085 31.8198 84.8425 31.8198L66.6301 31.8198C62.7641 31.8198 59.6301 28.6858 59.6301 24.8198V7Z",
    fill: "#DA716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwakenImg3);
export default __webpack_public_path__ + "static/media/awaken-img-3.817e1490c08db921ccc3e0f312b15472.svg";
export { ForwardRef as ReactComponent };